// @mui
import { IconButton } from '@mui/material';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en',
    icon: '/assets/BTN.png',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  return (
    <>
      <IconButton
        disabled
        sx={{
          padding: 0,
          width: 140,
          height: 100,
        }}
      >
        <img src={LANGS[0].icon} alt={LANGS[0].label} />
      </IconButton>
    </>
  );
}
